
import required from '../../../vendor/scripts/fabrique/modules/required'

export default class Component {
  constructor (element = required()) {
    this.element = element
    this.init()

    // We return this object to bind the instance.
    return this
  }

  static init () {
    // Override this method
  }
}
